module.exports = __webpack_public_path__ + "img/small-bissness-illustration@2x.8a3cc145.png";